import { render } from "./serverProtocol.vue?vue&type=template&id=d2149752"
const script = {}

import "./serverProtocol.vue?vue&type=style&index=0&id=d2149752&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__